export function getMockDataForMake(makes, dataType, mockData) {
  if (!makes || makes.length === 0) return null

  // If only one make selected, use original logic
  if (makes.length === 1) {
    return getSingleMakeData(makes[0], dataType, mockData)
  }

  // Multiple makes selected - combine data
  return getCombinedMakeData(makes, dataType, mockData)
}

/**
 * Get data for a single make
 */
function getSingleMakeData(make, dataType, mockData) {
  const makeName = (make.name || make.make || make || '').trim()
  const normalizedMakeName = makeName.toLowerCase()
  const availableBrands = Object.keys(mockData)

  const selectedBrand =
    // 1. Exact match
    availableBrands.find(brand => normalizedMakeName === brand.toLowerCase()) ||
    // 2. makeName contains brand name
    availableBrands.find(brand =>
      normalizedMakeName.includes(brand.toLowerCase())
    ) ||
    // 3. brand name contains makeName
    availableBrands.find(brand =>
      brand.toLowerCase().includes(normalizedMakeName)
    ) ||
    // 4. Handling camelCase as separate words
    availableBrands.find(brand => {
      const spacedBrand = brand
        .replace(/([A-Z])/g, ' $1')
        .toLowerCase()
        .trim()
      return (
        normalizedMakeName.includes(spacedBrand) ||
        spacedBrand.includes(normalizedMakeName)
      )
    })

  if (!selectedBrand) {
    return null
  }

  const brandData = mockData[selectedBrand]
  return brandData && brandData[dataType] ? brandData[dataType] : null
}

/**
 * Combine data from multiple makes
 */
function getCombinedMakeData(makes, dataType, mockData) {
  const validDataSets = []

  // Get data for each make
  for (const make of makes) {
    const singleData = getSingleMakeData(make, dataType, mockData)
    if (singleData && singleData.series && singleData.labels) {
      validDataSets.push(singleData)
    }
  }

  // If no valid data found, return null
  if (validDataSets.length === 0) {
    return null
  }

  // If only one valid dataset, return it
  if (validDataSets.length === 1) {
    return validDataSets[0]
  }

  // Combine multiple datasets
  const baseData = validDataSets[0]
  const combinedSeries = [...baseData.series]

  // Sum series data from all datasets
  for (let i = 1; i < validDataSets.length; i++) {
    const currentData = validDataSets[i]

    // Ensure all datasets have the same number of data points
    for (
      let j = 0;
      j < combinedSeries.length && j < currentData.series.length;
      j++
    ) {
      combinedSeries[j] =
        (combinedSeries[j] || 0) + (currentData.series[j] || 0)
    }
  }

  return {
    series: combinedSeries,
    labels: baseData.labels
  }
}
